module.exports = function() {
  return new Worker(__webpack_public_path__ + "a89d228ea5005e27c98c.worker.js");
};